'use client'

import { usePathname } from 'next/navigation'
import { useI18nAvailable } from '@/contexts/I18nContext'

/**
 * Hook to detect if the current route is within the i18n context
 * Returns true if:
 * 1. Pathname starts with /en, /es, or /pt (classic i18n routes)
 * 2. I18nContextProvider is available (booking system with cookie-based locale)
 */
export function useIsI18nContext(): boolean {
  const pathname = usePathname()

  // Check if pathname starts with locale prefix (classic i18n routes)
  const hasLocalePrefix = pathname?.startsWith('/en') || pathname?.startsWith('/es') || pathname?.startsWith('/pt')

  // Check if we're inside an I18nContextProvider (booking routes with NextIntlClientProvider)
  const hasI18nProvider = useI18nAvailable()

  return hasLocalePrefix || hasI18nProvider
}
